module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Safe-e8c1065c764a6ae2bc9ea0eed9147d29.svg";